"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionInformation = void 0;
class SessionInformation {
}
exports.SessionInformation = SessionInformation;
//# sourceMappingURL=SessionInformation.js.map